import React from "react";
import { Link } from "gatsby";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

import { getNavItemProps } from "../utils/utils";

import InfoEmailLink from "./InfoEmailLink";
import Logo from "./Logo";
import MobileStoreButton from "./MobileStoreButton";
import PhoneNumberLink from "./PhoneNumberLink";
import SocialProfiles from "./SocialProfiles";

import { useNavItems } from "../hooks/useNavItems";

import "../styles/components/Footer.scss";

const Footer = () => {
    const navItems = useNavItems({ showOnFooter: true });

    return (
        <footer className="footer">
            <Container>
                <Logo className="mb-3 mb-lg-0" />

                <Nav as={Row}>
                    <Col xs={6} lg={2}>
                        <p>Get in touch</p>
                        <InfoEmailLink className="contact-email" />
                        <PhoneNumberLink className="contact-phone" />

                        <p className="mt-3">Nurse Help Center</p>
                        <a
                            className="help-center"
                            href="https://help.shiftmed.com/en/"
                        >
                            help.shiftmed.com
                        </a>
                    </Col>

                    {navItems.map(navItem => {
                        if (!navItem?.childrenItems?.length) return null;

                        return (
                            <Col
                                key={navItem.id}
                                lg={2}
                                xs={6}
                                className="mb-4"
                            >
                                <Nav.Item className="highlighted">
                                    {navItem.title}
                                </Nav.Item>
                                {navItem.childrenItems.map(child => (
                                    <Nav.Link
                                        key={child.id}
                                        {...getNavItemProps(child)}
                                    >
                                        {child.title}
                                    </Nav.Link>
                                ))}
                            </Col>
                        );
                    })}

                    <Col xs={6} lg={2} className="mb-4">
                        <Nav.Item className="highlighted">Follow us</Nav.Item>
                        <SocialProfiles />

                        <Nav.Item className="highlighted">Get the app</Nav.Item>
                        <MobileStoreButton className="mb-1" brand="apple" />
                        <MobileStoreButton brand="google" />
                    </Col>
                </Nav>
                <Row className="mt-4 text-center align-items-end">
                    <Col lg={{ order: 2, span: 8 }} className="small-text">
                        <Link className="px-1" to="/cookie-policy/">
                            Cookie Policy
                        </Link>{" "}
                        |{" "}
                        <Link className="px-1" to="/terms/">
                            Terms & Conditions
                        </Link>{" "}
                        |{" "}
                        <Link className="px-1" to="/privacy/">
                            Privacy Policy
                        </Link>
                    </Col>
                    <Col
                        className="text-lg-start my-4 my-lg-0"
                        lg={{ order: 1, span: 2 }}
                    >
                        <a href="https://www.aicpa-cima.com/topic/audit-assurance/audit-and-assurance-greater-than-soc-2">
                            <StaticImage
                                src="../images/content/Compliance.png"
                                alt="Compliance Badge"
                                className="compliance-badge"
                            />
                        </a>
                    </Col>
                    <Col
                        lg={{ order: 3, span: 2 }}
                        className="d-flex justify-content-center"
                    >
                        <small className="small-text mt-3 mt-lg-0">
                            &copy; ShiftMed | All Rights Reserved
                        </small>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
